import { useEffect, useSyncExternalStore } from 'react'

import { useSettings } from '@loadsmart/react-frontend-settings'

import {
  getSettingsReady,
  observeSettingsLoading,
  subscribeSettingsReady,
} from 'core/infra/settings/settingsReadyStore'

/**
 * Returns `true` once the frontend settings provider has finished its initial
 * load, and stays `true` afterwards regardless of when the caller mounted.
 *
 * The reliable signal comes from the app-root probe (see `SettingsReadyProbe`),
 * which is guaranteed to be mounted while settings are loading. This hook also
 * feeds the store from its own render so it still settles when used in isolation
 * (e.g. in tests) without a separate probe.
 */
export function useSettingsSettled(): boolean {
  const { isLoading } = useSettings([])
  const isReady = useSyncExternalStore(subscribeSettingsReady, getSettingsReady, getSettingsReady)

  useEffect(() => {
    observeSettingsLoading(isLoading)
  }, [isLoading])

  return isReady
}
